import { Component, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SecurityService } from '../../security/security.service';
import { SystemMessageService } from '../../system-message/system-message-service';
import { validateForm } from '../../../shared/form-elements/form-validateForm.function';
import { ForgotPasswordVm } from '../../../shared/generated/Models/ForgotPasswordVm';

@Component({
    selector: 'pcg-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnDestroy, AfterViewInit {
	forgotPasswordForm = ForgotPasswordVm.Form;
	forgotPasswordSub: Subscription = new Subscription();
	checkEmail = false;

	constructor(
		private route: ActivatedRoute,
		private fb: UntypedFormBuilder,
		private ms: SystemMessageService,
		private sec: SecurityService,
		private router: Router
	) {}

	ngAfterViewInit() {}

	onSubmit() {
		if (this.forgotPasswordForm.valid) {
			this.forgotPasswordSub.add(
				this.ms
					.getHttpObservable(this, 'api/Account/ForgotPassword', this.forgotPasswordForm)
					.subscribe(msg => {
						if (msg?.isSuccessful) {
							this.checkEmail = true;
						}
					})
			);
		} else {
			validateForm(this.forgotPasswordForm);
		}
	}

	ngOnDestroy() {
		this.forgotPasswordSub.unsubscribe();
	}
}
